import { TActions } from '../../../AppModulesWrapper';

import { IBalanceState } from '../../types/reducers/balance';
import { UPDATE_BALANCE, UPDATE_RECOMMENDED_DEPOSIT_AMOUNT } from '../../actions/balance';

import { defaultState } from './defaultState';
import { RESET_STATE } from '../../actions/resetState';

export const balance = (state: IBalanceState = defaultState, action: TActions): IBalanceState => {
  switch (action.type) {
    case UPDATE_BALANCE:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_RECOMMENDED_DEPOSIT_AMOUNT:
      return {
        ...state,
        recommendedDepositAmount: action.payload,
      };

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
